import { Component, ElementRef, inject, viewChild } from '@angular/core';
import { NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { IDateParams } from 'ag-grid-community';
import { IDateAngularComp } from 'ag-grid-angular';

import { DateFormatService } from '../../../../services';

@Component({
  selector: 'app-custom-date',
  templateUrl: './date-filter.component.html',
  styleUrl: './date-filter.component.scss',
  imports: [NgbInputDatepicker],
})
export class DateFilterComponent implements IDateAngularComp {
  private readonly dateFormatService = inject(DateFormatService);

  private readonly datePicker = viewChild('datePicker', { read: ElementRef });
  private date: any;
  private params: IDateParams;

  agInit(params: IDateParams): void {
    this.params = params;
  }

  onDateChanged(date: string) {
    this.date = this.dateFormatService.dateFromString(date);
    this.params.onDateChanged();
  }

  onDatePicked(date: NgbDateStruct) {
    this.date = this.dateFormatService.dateFromNgbDate(date);
    this.params.onDateChanged();
  }

  getDate(): Date {
    return this.date;
  }

  setDate(date: Date): void {
    this.date = date || undefined;
    this.datePicker().nativeElement.value = date;
  }

  setInputPlaceholder(placeholder: string): void {
    // ignore placeholder here (default of yyyy-mm-dd will be populated if we use this function which isn't what we want)
  }

  setInputAriaLabel(label: string): void {
    this.datePicker().nativeElement.setAttribute('aria-label', label);
  }
}
